import { fontSize, fontWeight, lineHeight } from "../../../../constants/typography";
import { NeutralColors } from "../../../../constants/colors";
import { spacing } from "../../../../util/spacing";
import styled from 'styled-components';
export var UserInfoBox = styled.div.withConfig({
  componentId: "sc-17jl7hx-0"
})(["display:flex;padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";gap:", ";align-items:center;"], spacing(2), spacing(2), spacing(0.5), spacing(0.5), spacing(2));
export var UserDetails = styled.div.withConfig({
  componentId: "sc-17jl7hx-1"
})(["display:flex;flex-direction:column;min-width:0;"]);
export var UserName = styled.span.withConfig({
  componentId: "sc-17jl7hx-2"
})(["font-size:", ";font-weight:", ";line-height:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], fontSize.xSmall, fontWeight.medium, lineHeight.medium);
export var UserEmail = styled.span.withConfig({
  componentId: "sc-17jl7hx-3"
})(["font-size:", ";color:", ";line-height:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], fontSize.x2Small, NeutralColors.Grey700, lineHeight.large);